module.exports = __webpack_public_path__ + "img/hero-canberra@2x.4ef076bb.jpg";